import { Injectable } from '@angular/core';
import { FlatAddress } from '@models/address';
import { AddressAttributes, LoadCountryListQuery } from '@queries/generated';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  countries$ = this.loadCountryListQuery.watch().valueChanges.pipe(map(({ data }) => data.countries));

  constructor(private loadCountryListQuery: LoadCountryListQuery) {}

  hasExpectedValues(
    address:
      | Pick<FlatAddress, 'address1' | 'city' | 'country' | 'countryCode' | 'province' | 'provinceCode' | 'postalCode'>
      | Pick<AddressAttributes, 'address1' | 'city' | 'country' | 'province' | 'postalCode'>
  ) {
    return (
      address &&
      address.address1 &&
      address.city &&
      (address.country || address['countryCode']) &&
      (address.province || address['provinceCode']) &&
      address.postalCode
    );
  }
}
